<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">💎</span>
          </div>
          <h1 class="title-glow">{{ $t('cashback_page.title') }}</h1>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Banner Section -->
      <div class="banner-section">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/connextcc-asia/o/images%2F%E0%B8%A2%E0%B8%AD%E0%B8%94%E0%B9%80%E0%B8%AA%E0%B8%B5%E0%B8%A2%E0%B8%A7%E0%B8%B1%E0%B8%99%E0%B8%88%E0%B8%B1%E0%B8%99%E0%B8%97%E0%B8%A3%E0%B9%8C.JPG?alt=media&token=274bf11f-1116-49af-bd02-61422456d9de"
          class="banner-image"
          alt="Cashback Banner"
        >
      </div>

      <!-- Stats Title -->
      <div class="stats-title">{{ $t('cashback_page.title2') }}</div>

      <!-- Stats Cards -->
      <div class="cashback-stats">
        <div class="stat-card">
          <div class="stat-icon">📥</div>
          <div class="stat-label">{{ $t('deposit') }}</div>
          <div class="stat-value">{{ numberWithCommas(this.cashback.deposit )}}</div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">📤</div>
          <div class="stat-label">{{ $t('withdraw') }}</div>
          <div class="stat-value">{{ numberWithCommas(this.cashback.withdraw )}}</div>
        </div>

        <div class="stat-card stat-card-highlight">
          <div class="stat-icon">💰</div>
          <div class="stat-label">{{ $t('partner_title6') }}</div>
          <div class="stat-value stat-value-large">{{ numberWithCommas(this.cashback.total )}}</div>
        </div>
      </div>

      <!-- Claim Button -->
      <div class="claim-section">
        <button
          @click="moveCashbackToWallet()"
          :class="['claim-btn', { 'claim-btn-disabled': !cashback.total || cashback.total <= 0 }]"
          :disabled="!cashback.total || cashback.total <= 0 || disabled"
        >
          {{ $t('partner_title7') }}
        </button>
      </div>

      <!-- Details Section -->
      <div class="details-section" v-if="detail">
        <div class="details-card">
          <div v-html="nl2br(detail)" class="details-text"></div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail: '',
      disabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    async waitForCashbackClaimResult (key, attempts = 10) {
      for (let attempt = 0; attempt < attempts; attempt++) {
        const snapshot = await firebase.firestore().collection('cashback').doc(key).get()
        const data = snapshot.exists ? (snapshot.data() || {}) : {}
        if (data.status === true) return { status: true, total: Number(data.total || 0) }
        if (data.blocked_reason || data.error) {
          return {
            status: false,
            code: data.blocked_reason || 'CASHBACK_CLAIM_BLOCKED',
            error: data.error || 'ไม่สามารถรับคืนยอดเสียได้ในขณะนี้'
          }
        }
        await new Promise(resolve => setTimeout(resolve, 500))
      }
      return {
        status: false,
        code: 'CASHBACK_CLAIM_TIMEOUT',
        error: 'ระบบกำลังตรวจสอบรายการ กรุณารอสักครู่แล้วลองใหม่อีกครั้ง'
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    async moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key && !this.disabled) {
        this.disabled = true
        this.$store.commit('user/SET_LOADING', true)
        try {
          const claim = await axios.get(`https://api.connextcc.cc/qcashback/cashback/${this.cashback.key}`)
          let result = claim && claim.data ? claim.data : {}
          if (result.status === undefined && result.id) {
            result = await this.waitForCashbackClaimResult(this.cashback.key)
          }
          if (!result.status) {
            this.$swal({ icon: 'error', title: 'ไม่สามารถรับคืนยอดเสียได้', text: result.error || 'กรุณาลองใหม่อีกครั้ง' })
            return
          }
          await this.getCashBack()
          this.$swal({ icon: 'success', title: 'รับคืนยอดเสียสำเร็จ', text: `เพิ่มเครดิต ${Number(result.total || 0).toLocaleString()} บาทแล้วค่ะ` })
        } catch (error) {
          const message = error && error.response && error.response.data && error.response.data.error
          this.$swal({ icon: 'error', title: 'ไม่สามารถรับคืนยอดเสียได้', text: message || 'กรุณาลองใหม่อีกครั้ง' })
        } finally {
          this.$store.commit('user/SET_LOADING', false)
          this.disabled = false
        }
      }
    },
    checkStyle () {
      if (this.cashback && this.cashback.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
     nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref(`/cashback/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        return firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>
<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #2b2727 0%, #1b1b1b 50%, #2b2727 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 40px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(247, 178, 66, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(247, 178, 66, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(247, 178, 66, 0.5),
    0 0 40px rgba(247, 178, 66, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #f7b242, #ce840c);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #ce840c, #f7b242);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #2b2727, #f7b242);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 30px 20px;
  max-width: 900px;
}

/* Banner Section */
.banner-section {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.banner-image {
  width: 100%;
  height: auto;
  display: block;
}

/* Stats Title */
.stats-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #f7b242;
  margin-bottom: 25px;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.3);
}

/* Cashback Stats */
.cashback-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 25px 20px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: rgba(247, 178, 66, 0.4);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(247, 178, 66, 0.2);
}

.stat-card-highlight {
  border-color: rgba(247, 178, 66, 0.4);
  background: rgba(247, 178, 66, 0.05);
}

.stat-icon {
  font-size: 40px;
  margin-bottom: 15px;
  filter: drop-shadow(0 2px 8px rgba(247, 178, 66, 0.3));
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
  font-weight: 500;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #f7b242;
  text-shadow: 0 0 15px rgba(247, 178, 66, 0.4);
}

.stat-value-large {
  font-size: 28px;
  text-shadow: 0 0 20px rgba(247, 178, 66, 0.5);
}

/* Claim Button Section */
.claim-section {
  text-align: center;
  margin-bottom: 40px;
}

.claim-btn {
  background: linear-gradient(135deg, #f7b242, #ce840c);
  border: none;
  border-radius: 8px;
  padding: 15px 40px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: 'Kanit', sans-serif;
  box-shadow:
    0 4px 15px rgba(247, 178, 66, 0.3),
    0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 200px;
}

.claim-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 20px rgba(247, 178, 66, 0.4),
    0 3px 8px rgba(0, 0, 0, 0.3);
  filter: brightness(1.1);
}

.claim-btn-disabled,
.claim-btn:disabled {
  background: linear-gradient(135deg, #666, #444);
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

.claim-btn-disabled:hover,
.claim-btn:disabled:hover {
  transform: none;
  filter: none;
}

/* Details Section */
.details-section {
  margin-top: 40px;
}

.details-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(247, 178, 66, 0.2);
  border-radius: 12px;
  padding: 30px 25px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(247, 178, 66, 0.1);
}

.details-text {
  text-align: center;
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
}

/* Tablet Responsive */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 35px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .cashback-stats {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .stat-icon {
    font-size: 36px;
  }

  .stat-value {
    font-size: 22px;
  }

  .stat-value-large {
    font-size: 26px;
  }
}

/* Mobile Responsive */
@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 30px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .main-content {
    padding: 20px 15px;
  }

  .stats-title {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .stat-card {
    padding: 20px 15px;
  }

  .stat-icon {
    font-size: 32px;
    margin-bottom: 10px;
  }

  .stat-label {
    font-size: 13px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-value-large {
    font-size: 24px;
  }

  .claim-btn {
    padding: 12px 30px;
    font-size: 14px;
    min-width: 180px;
  }

  .details-card {
    padding: 25px 20px;
  }

  .details-text {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>
